import axios from '@/jslib/axios'
export const sortTravellerTeam = (data) => {
  return axios({
    method: 'post',
    url: '/admin/pop/traveller/team/sort',
    data
  })
}
export const presignedTraveller = data => {
  return axios({
    method: 'post',
    url: '/admin/pop/traveller/presigned',
    data
  })
}
export const presignedDoneTraveller = data => {
  return axios({
    method: 'post',
    url: '/admin/pop/traveller/presigned/done',
    data
  })
}
export const createTravellerTeam = data => {
  return axios({
    method: 'post',
    url: '/admin/pop/traveller/team/create',
    data
  })
}

export const controlVoteTraveller = data => {
  return axios({
    method: 'post',
    url: '/admin/pop/traveller/control/vote',
    data
  })
}
export const getPopTravellerDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/pop/traveller/team/detail',
    params
  })
}
export const addPopTravellerRemark = data => {
  return axios({
    method: 'post',
    url: '/admin/pop/traveller/add/remark',
    data
  })
}
export const postToAmazonS3 = data => {
  return axios({
    method: 'post',
    url: 'https://holdcover.s3.ap-east-1.amazonaws.com',
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  })
}
export const getTravellerTeamList = params => {
  return axios({
    method: 'get',
    url: '/admin/pop/traveller/team/list',
    params
  })
}
